<template>
  <div>
    <div class="bottom-area flex-center-center fz14">
        <div class="fc9 mr15">技术支持：</div>
        <img class="icon-logo mr10" src="@/assets/image-bottom.png" alt/>
        <div><a class="fcf" target="_blank" href="https://www.gaskmp.cn/">全国电子印章管理与服务平台</a></div>
        <img class="icon-logo ml25 mr10" src="@/assets/logo-red.png" alt/>
        <div class="fcf"><a class="fcf" target="_blank" href="https://www.lngsyz.com/">{{ baseName }}</a></div>
        <el-tooltip
          class="ml25"
          placement="top" trigger="hover" effect="light"
        >
          <template slot="content">
            <div style="width: 240px; height: 240px">
              <img
                  src="@/assets/qr-wx-gzh.png"
                  alt
                  style="width: 100%; height: 100%"
              />
            </div>
          </template>

<!--          <img class="wx-logo pointer ml25 mr10" src="@/assets/wx-gzh.png" alt/>-->
          <i class="iconfont el-icon-wxgzh wx-logo pointer ml25 mr10"></i>
        </el-tooltip>
        <el-tooltip
          class="ml25"
          placement="top" trigger="hover" effect="light"
        >
          <template slot="content">
            <div style="width: 240px; height: 240px">
              <img
                  src="@/assets/qr-wx-xcx.jpg"
                  alt
                  style="width: 100%; height: 100%"
              />
            </div>
          </template>

<!--          <img class="wx-logo pointer ml25 mr10" src="@/assets/wx-xcx.png" alt/>-->
          <i class="iconfont el-icon-wxxcx wx-logo pointer ml25 mr10"></i>
        </el-tooltip>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      baseName: '辽宁广烁科技有限公司',
    };
  },
};
</script>
<style lang="less" scoped>
.bottom-area {
    position: fixed;
    bottom: 0px;
    width: 100%;
    min-width: 1200px;
    height: 48px;
    line-height: 48px;
    background: #333;
    z-index: 99999;

    .icon-logo {
        width: 14px;
        height: 14px;
    }

    .wx-logo {
      font-size: 24px;
      color: #7F8997
    }

    .wx-logo:hover {
      font-size: 24px;
      color: #FFFFFF
    }

    a {
        text-decoration: none;
    }
}
</style>
